import React from 'react';
import ReactDOM from 'react-dom';
import { ComponentWrapper } from './ComponentWrapper';

export const renderComponent = (
  children: React.ReactChild,
  container: HTMLElement,
) => {
  ReactDOM.render(<ComponentWrapper>{children}</ComponentWrapper>, container);
};



// WEBPACK FOOTER //
// ./app/gamma/src/components/renderComponent.tsx